import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';
import { TranslateFunction } from 'react-localize-redux';

import { DashboardCard } from '@fd/ui/atoms';

const useStyles = makeStyles(() => ({
  downloads: {
    fontSize: '1.5rem',
    fontWeight: 400,
  },
}));

export type AppDownloadsCardProps = {
  downloads?: number;
  isLoading?: boolean;
  translate: TranslateFunction;
};

export const AppDownloadsCard = (props: AppDownloadsCardProps) => {
  const { isLoading, downloads = 0, translate } = props;
  const classes = useStyles();

  return (
    <DashboardCard isLoading={isLoading} title={translate('Number_of_downloads') as string}>
      <Typography className={classes.downloads} variant="body1">
        {downloads}
      </Typography>
    </DashboardCard>
  );
};
